import { Link } from "@tanstack/react-router";
import { ArrowLeft, Mail } from "lucide-react";
import type { ReactNode } from "react";

export const CONTACT_EMAIL = "vipusa8400@gmail.com";

export function LegalPage({
  title,
  updated,
  intro,
  children,
}: {
  title: string;
  updated: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/60 bg-navy-soft">
        <div className="container-tight flex items-center justify-between py-5">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-navy-foreground/80 transition-colors hover:text-gold"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="inline-flex items-center gap-2 text-xs font-semibold text-navy-foreground/70 transition-colors hover:text-gold"
          >
            <Mail className="h-3.5 w-3.5" />
            {CONTACT_EMAIL}
          </a>
        </div>
      </header>

      <main className="container-tight py-14 md:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
          Legal
        </p>
        <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
          {title}
        </h1>
        <p className="mt-2 text-xs text-muted-foreground">Last updated: {updated}</p>
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground">
          {intro}
        </p>
        <div className="mt-10 max-w-3xl space-y-8">{children}</div>
      </main>
    </div>
  );
}

export function LegalSection({
  heading,
  children,
}: {
  heading: string;
  children: ReactNode;
}) {
  return (
    <section>
      <h2 className="text-lg font-bold tracking-tight text-foreground">{heading}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground">
        {children}
      </div>
    </section>
  );
}
